module.exports = __webpack_public_path__ + "media/images/play-button-429328144dd887e265d3e302b3f7a261.svg";